import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from 'contexts/UserContext'
import { SchemaAndIntervals } from 'models/schema'
import { currentQueryService } from 'utils/api/queries'
import { useSingleSelectedCompany } from 'utils/hooks/useSingleSelectedCompany'

const useGetSchema = () => {
  const { authenticatedUser } = useAuthenticatedUser()
  const { hasSingleSelection, selectedCompany } = useSingleSelectedCompany()

  const userId = authenticatedUser?.clientPrincipal?.userId as string
  const companyId = hasSingleSelection ? selectedCompany?.id || '' : ''
  const isEnabled = Boolean(userId && companyId)

  const query = useQuery<SchemaAndIntervals, Error>({
    queryKey: ['useGetSchema', userId, companyId],
    queryFn: () => currentQueryService.getSchema(userId, companyId),
    enabled: isEnabled,
    retry: 0,
  })

  return { ...query, requiresSingleSelection: !hasSingleSelection }
}

export { useGetSchema }
